// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1wAkj","col":"styles_col__4eYfw"};